import f1 from'../../../pip/library/pi-f1/pi-f1.js';

import { Resource, IResource } from './resource';

export interface IStateful {
  /**
   * invoked by a micro when the uri changes (the state of the micro application)
   */
  stateChange?(): Promise<this>;
}

/**
 * A service manages or monitors a global process, for instance, monitor user activity or
 * performance monitoring, or attaching properties to all HTTP requests.
 *
 * A service is injectable to other services and through the Service Hub it is attached to.
 *
 * Generally a product will register Services to provide all "core" functionality, which all
 * Micro Applications depend on to function properly.
 */
export interface IService extends IResource, IStateful {
  /**
   * @readonly
   * the service of the service hub this service participates in
   */
  ns: string;
}

/**
 * A Service
 */
export class Service extends Resource implements IService {
  /**
   * @readonly
   * This is assigned by the ServiceHub you connect this service to
   */
  ns: string;

  /**
   * Invoked when the URI is changed (this is on a `hashchange`)
   */
  stateChange() {
    return f1.done(this);
  }
}
